module.exports = __webpack_public_path__ + "img/ECCMID_logo.e4e426e2.jpg";